<template>
  <div class="l-content content_works">

    <div class="l-mv">
      <h2 class="title_content font_ltc">WORKS</h2>
    </div>

    <div class="wrap_shop">

      <q-item class="wrap_avatar">
        <div class="inner_avater flex no-wrap">
          <q-item-section>
            <q-item-label class="title_shop font_sw">実績例</q-item-label>
          </q-item-section>
        </div>

       <!-- <q-select outlined v-model="model" :options="options" label="並び替え" class="wrap_select" /> -->
      </q-item>

      <div class="wrap_serchresult">


        <div class="row inner_scroll">
          <div style="width: 340px" class="search_item">

            <q-card class="my-card">

              <div class="q-pa-md wrap_carousel_serchresult">
                <q-carousel
                  swipeable
                  animated
                  v-model="slide1"
                  thumbnails
                  infinite
                >
                  <q-carousel-slide :name="1" img-src="/img/img-works08.jpg" />
                  <q-carousel-slide :name="2" img-src="/img/img-works09.jpg" />
                </q-carousel>
              </div>

              <q-item class="wrap_text_item">
<!--                  <q-item-section avatar>-->
<!--                    <q-avatar>-->
<!--                      <img src="https://cdn.quasar.dev/img/avatar1.jpg">-->
<!--                    </q-avatar>-->
<!--                  </q-item-section>-->

                <q-item-section class="wrap_text_works">
                  <q-item-label>
                    <span class="title_works">
                      （兵庫県神戸市）auショップ鈴蘭台店
                    </span>
                  </q-item-label>
<!--                    <q-item-label caption>-->
<!--                      <span class="subtitle_works">-->
<!--                        担当者名-->
<!--                      </span>-->
<!--                    </q-item-label>-->
                </q-item-section>

<!--                  <div class="text_price">-->
<!--                    <span class="en">￥</span>-->
<!--                    <span class="normal">-->
<!--                      -->
<!--                    </span>-->
<!--                          <br>-->
<!--                          <span class="small text_tax">-->
<!--                      -->
<!--                    </span>-->
<!--                  </div>-->

              </q-item>

              <q-separator />

              <!-- <q-card-actions class="wrap_menu_item">
                <q-btn label="詳細を見る" color="primary" @click="fixed = true" class="btn_detail" />

                <q-dialog v-model="fixed">
                  <q-card>
                    <q-card-section>
                      <div class="text-h6">実績タイトル</div>
                    </q-card-section>

                    <q-separator />

                    <q-card-section style="max-height: 67vh" class="scroll">
                      <img src="https://www.g-mark.org/media/award/2018/18G121000/18G121000_02_880x660.jpg?w=880&h=660&m=0" class="img_works_detail">
                      <p v-for="n in 2" :key="n" class="text_works_detail">
                        実績の詳細分が入ります。この文章はfor文で繰り返しています。実績の詳細分が入ります。この文章はfor文で繰り返しています。実績の詳細分が入ります。この文章はfor文で繰り返しています。実績の詳細分が入ります。この文章はfor文で繰り返しています。実績の詳細分が入ります。この文章はfor文で繰り返しています。実績の詳細分が入ります。この文章はfor文で繰り返しています。
                      </p>

                      <img src="https://images.keizai.biz/hongkong_keizai/headline/1532842104_photo.jpg" class="img_works_detail">

                      <p v-for="n in 2" :key="n" class="text_works_detail">
                        実績の詳細分が入ります。この文章はfor文で繰り返しています。実績の詳細分が入ります。この文章はfor文で繰り返しています。実績の詳細分が入ります。この文章はfor文で繰り返しています。実績の詳細分が入ります。この文章はfor文で繰り返しています。実績の詳細分が入ります。この文章はfor文で繰り返しています。実績の詳細分が入ります。この文章はfor文で繰り返しています。
                      </p>

                    </q-card-section>

                    <q-separator />

                    <q-card-actions align="right">
                      <q-btn flat label="閉じる" color="primary" />
                    </q-card-actions>
                  </q-card>
                </q-dialog>


                <q-btn color="white" text-color="primary" label="スキームを見る" class="btn_favorite" />

                <div class="col-auto btn_other">
                  <q-btn color="grey-7" round flat icon="more_vert">
                    <q-menu cover auto-close>
                      <q-list>
                        <q-item clickable>
                          <q-item-section>メニュー1</q-item-section>
                        </q-item>
                        <q-item clickable>
                          <q-item-section>メニュー2</q-item-section>
                        </q-item>
                        <q-item clickable>
                          <q-item-section>メニュー3</q-item-section>
                        </q-item>
                      </q-list>
                    </q-menu>
                  </q-btn>
                </div>
              </q-card-actions> -->

            </q-card>

          </div>


          <div style="width: 340px" class="search_item">
            <q-card class="my-card">
              <div class="q-pa-md wrap_carousel_serchresult">
                <q-carousel
                  swipeable
                  animated
                  v-model="slide2"
                  thumbnails
                  infinite
                >
                  <q-carousel-slide :name="1" img-src="/img/img-works07.jpg" />
                  <q-carousel-slide :name="2" img-src="/img/img-works06.jpg" />
                </q-carousel>
              </div>
              <q-item class="wrap_text_item">
                <q-item-section class="wrap_text_works">
                  <q-item-label>
                    <span class="title_works">
                      （兵庫県神戸市）あっぷる神戸有馬店
                    </span>
                  </q-item-label>
                </q-item-section>
              </q-item>
              <q-separator />
            </q-card>
          </div>


          <div style="width: 340px" class="search_item">
            <q-card class="my-card">
              <div class="q-pa-md wrap_carousel_serchresult">
                <q-carousel
                  swipeable
                  animated
                  v-model="slide3"
                  thumbnails
                  infinite
                >
                  <q-carousel-slide :name="1" img-src="/img/img-works03.jpg" />
                  <q-carousel-slide :name="2" img-src="/img/img-works05.jpg" />
                  <q-carousel-slide :name="3" img-src="/img/img-works01.jpg" />
                  <q-carousel-slide :name="4" img-src="/img/img-works04.jpg" />
                </q-carousel>
              </div>
              <q-item class="wrap_text_item">
                <q-item-section class="wrap_text_works">
                  <q-item-label>
                    <span class="title_works">
                      （兵庫県尼崎市）尼崎不動産売買※４件同時決済
                    </span>
                  </q-item-label>
                </q-item-section>
              </q-item>
              <q-separator />
            </q-card>
          </div>


          <div style="width: 340px" class="search_item">
            <q-card class="my-card">
              <div class="q-pa-md wrap_carousel_serchresult">
                <q-carousel
                  swipeable
                  animated
                  v-model="slide4"
                  thumbnails
                  infinite
                >
                  <q-carousel-slide :name="1" img-src="/img/img-works02a.jpg" />
                  <q-carousel-slide :name="2" img-src="/img/img-works02.jpg" />
                </q-carousel>
              </div>
              <q-item class="wrap_text_item">
                <q-item-section class="wrap_text_works">
                  <q-item-label>
                    <span class="title_works">
                      （滋賀県近江八幡市）ウエルシア近江八幡鷹飼店
                    </span>
                  </q-item-label>
                </q-item-section>
              </q-item>
              <q-separator />
            </q-card>
          </div>

          <div style="width: 340px" class="search_item">
            <q-card class="my-card">
              <div class="q-pa-md wrap_carousel_serchresult">
                <q-carousel
                  swipeable
                  animated
                  v-model="slide5"
                  thumbnails
                  infinite
                >
                  <q-carousel-slide :name="1" img-src="/img/img-works12.jpg" />
                </q-carousel>
              </div>
              <q-item class="wrap_text_item">
                <q-item-section class="wrap_text_works">
                  <q-item-label>
                    <span class="title_works">
                      (大阪府大阪市) ドラッグアカカベ木川東店
                    </span>
                  </q-item-label>
                </q-item-section>
              </q-item>
              <q-separator />
            </q-card>
          </div>

          <div style="width: 340px" class="search_item">
            <q-card class="my-card">
              <div class="q-pa-md wrap_carousel_serchresult">
                <q-carousel
                  swipeable
                  animated
                  v-model="slide6"
                  thumbnails
                  infinite
                >
                  <q-carousel-slide :name="1" img-src="/img/img-works13.jpg" />
                </q-carousel>
              </div>
              <q-item class="wrap_text_item">
                <q-item-section class="wrap_text_works">
                  <q-item-label>
                    <span class="title_works">
                      (京都府宇治市) 激安新鮮市場！六地蔵店/エニタイムフィットネス六地蔵店他複合
                    </span>
                  </q-item-label>
                </q-item-section>
              </q-item>
              <q-separator />
            </q-card>
          </div>

          <div style="width: 340px" class="search_item">
            <q-card class="my-card">
              <div class="q-pa-md wrap_carousel_serchresult">
                <q-carousel
                  swipeable
                  animated
                  v-model="slide7"
                  thumbnails
                  infinite
                >
                  <q-carousel-slide :name="1" img-src="/img/img-works14.jpg" />
                </q-carousel>
              </div>
              <q-item class="wrap_text_item">
                <q-item-section class="wrap_text_works">
                  <q-item-label>
                    <span class="title_works">
                      (佐賀県佐賀市) NTTドコモ佐賀夢咲店
                    </span>
                  </q-item-label>
                </q-item-section>
              </q-item>
              <q-separator />
            </q-card>
          </div>

          <div style="width: 340px" class="search_item">
            <q-card class="my-card">
              <div class="q-pa-md wrap_carousel_serchresult">
                <q-carousel
                  swipeable
                  animated
                  v-model="slide8"
                  thumbnails
                  infinite
                >
                  <q-carousel-slide :name="1" img-src="/img/img-works15.jpg" />
                </q-carousel>
              </div>
              <q-item class="wrap_text_item">
                <q-item-section class="wrap_text_works">
                  <q-item-label>
                    <span class="title_works">
                      (兵庫県神戸市) ゴダイドラッグ玉津新方店
                    </span>
                  </q-item-label>
                </q-item-section>
              </q-item>
              <q-separator />
            </q-card>
          </div>


        </div>

        <!-- <q-btn-group class="q-mb-md wrap_btn_more center">
          <q-btn color="secondary" @click="more">もっと表示</q-btn>
          <q-btn color="primary" @click="less">少なく表示</q-btn>
        </q-btn-group> -->
      </div>

    </div>


    <div class="wrap_shop">

      <q-item class="wrap_avatar">
        <div class="inner_avater flex no-wrap">
          <q-item-section>
            <q-item-label class="title_shop font_sw">実績例</q-item-label>
          </q-item-section>
        </div>

       <!-- <q-select outlined v-model="model" :options="options" label="並び替え" class="wrap_select" /> -->
      </q-item>

      <div class="wrap_serchresult">


        <div class="row">
          <div class="l-wide">
            <!-- <q-table
              style="font-size: 20px !important"
              title="実績"
              class="table_q"
              :data="data"
              :columns="columns"
              row-key="index"
              virtual-scroll
              :pagination.sync="pagination"
              :rows-per-page-options="[0]"
            /> -->

            <div class="wrap_table">
              <table>
                <thead>
                  <tr>
                    <th>エリア</th>
                    <th>実績名</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>兵庫県神戸市西区</td>
                    <td>物販店舗跡地テナント計画</td>
                  </tr>
                  <!-- <tr>
                    <td>02</td>
                    <td>兵庫県尼崎市</td>
                    <td>所有地4土地一括売却売買仲介</td>
                  </tr> -->
                  <!-- <tr>
                    <td>03</td>
                    <td>兵庫県神戸市北区</td>
                    <td>既存テナント契約更新コンサルティング</td>
                  </tr> -->
                  <tr>
                    <td>佐賀県佐賀市兵庫北</td>
                    <td>携帯ショップ計画</td>
                  </tr>
                  <tr>
                    <td>大分県大分市金池町</td>
                    <td>ホテル新築計画</td>
                  </tr>
                  <tr>
                    <td>兵庫県西宮市</td>
                    <td>不動産売買仲介＋テナント計画</td>
                  </tr>
                  <!-- <tr>
                    <td>07</td>
                    <td>兵庫県神戸市西区</td>
                    <td>ドラッグストア有効活用</td>
                  </tr> -->
                  <tr>
                    <td>京都府宇治市</td>
                    <td>スーパー建替え＋複合テナント計画</td>
                  </tr>
                  <!-- <tr>
                    <td>09</td>
                    <td>兵庫県神戸市長田区</td>
                    <td>ドラッグストア有効活用</td>
                  </tr> -->
                  <tr>
                    <td>石川県金沢市</td>
                    <td>ホテル新築計画</td>
                  </tr>
                  <tr>
                    <td>大阪府大阪市</td>
                    <td>ドラッグストア計画</td>
                  </tr>
                  <tr>
                    <td>兵庫県神戸市北区</td>
                    <td>中古車販売場計画</td>
                  </tr>
                  <!-- <tr>
                    <td>13</td>
                    <td>滋賀県近江八幡市</td>
                    <td>ドラッグストア有効活用</td>
                  </tr> -->
                  <tr>
                    <td>兵庫県神戸市北区</td>
                    <td>携帯ショップ計画</td>
                  </tr>
                  <tr>
                    <td>大阪府大阪市浪速区</td>
                    <td>コンビニエンスストア計画</td>
                  </tr>
                  <tr>
                    <td>神戸市西区</td>
                    <td>ゴダイ ドラッグストア</td>
                  </tr>
                  <tr>
                    <td>京都府宇治市</td>
                    <td>スーパー建替え＋複合テナント計画</td>
                  </tr>
                  <tr>
                    <td>大阪府大阪市</td>
                    <td>アカカベ ドラッグストア計画</td>
                  </tr>
                  <tr>
                    <td>佐賀県佐賀市兵庫北</td>
                    <td>佐賀ドコモ 携帯ショップ計画</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>

</template>

<script>
    const seed = [
      {
        name: '兵庫県神戸市西区',
        fat: '物販店舗跡地テナント計画'
      },
      {
        name: '兵庫県尼崎市',
        fat: '所有地4土地一括売却売買仲介'
      }
    ]

    // we generate lots of rows here
    let data = []
    for (let i = 0; i < 1; i++) {
      data = data.concat(seed.slice(0).map(r => ({ ...r })))
    }
    data.forEach((row, index) => {
      row.index = index
    })

    // we are not going to change this array,
    // so why not freeze it to avoid Vue adding overhead
    // with state change detection
    Object.freeze(data)
    
    export default {
        name: 'SerchResult',
        data () {
            return {
              data,
              pagination: {
                  rowsPerPage: 0
                },
                columns: [
                  {
                    name: 'index',
                    label: '#',
                    field: 'index'
                  },
                  {
                    name: 'name',
                    required: true,
                    label: 'エリア',
                    align: 'left',
                    field: row => row.name,
                    format: val => `${val}`,
                    sortable: true
                  },
                  { name: 'fat', label: '実績名', align: 'left', field: 'fat', sortable: true }
                ],

                //select
                model: null,
                options: [
                    '価格順', '新着順', '人気順', 'オプション', 'オプション'
                ],
                //for Carousel
                slide: 1,
                slide1: 1,
                slide2: 1,
                slide3: 1,
                slide4: 1,
                slide5: 1,
                slide6: 1,
                slide7: 1,
                slide8: 1,

                //pagination
                // current: 3,

                //scrollarea
                number: 1,

                //privacy policy
                fixed: false,
            }
        },
        methods: {
            less () {
                if (this.number > 1) {
                    this.number--
                }
            },

            more () {
                this.number++
            }
        },
        computed: {
          layout () {
            return this.$q.screen.lt.sm ? 'dense' : (this.$q.screen.lt.md ? 'comfortable' : 'loose')
          }
        }
    }
</script>


<style scoped lang="stylus">
.l-wide {
  width 100%
  max-width 800px
  margin 0 auto
}
.inner_scroll {
  padding-bottom: 80px;
}
.wrap_shop {
  &:not(:first-child) {
    margin-top: 0;
  }
}
.btn_detail
  width auto
  margin-left auto
@media only screen and (max-width: 767px) {
  .btn_detail {
    width 100%
  }
}
@media (min-width: 600px) {
  .q-dialog__inner--minimized > div {
    max-width: 840px !important;
  }
}

.text_works_detail
  font-size 15px
  line-height 1.6
  letter-spacing .05em

.img_works_detail
  display block
  width 100%
  margin-bottom 16px
  border-radius 5px

.wrap_text_works
  padding-left 8px

.title_works
  display block
  padding-top 5px
  font-size 16px
  line-height 1.5

.subtitle_works
  display block
  margin-top 1px
  font-size 12px

.inner_avater
  margin-left 1%
  @media only screen and (max-width: 767px) {
    justify-content center
    width 100%
    text-align center
  }

.wrap_select
  position relative
  z-index 10
  width 200px
  margin-top 8px
  margin-right 0.7%
  margin-left auto
  background-color #fff
  @media only screen and (max-width: 767px) {
    max-width 767px
    width 100%
    margin 10px 0 0
  }
.wrap_serchresult
  padding 1% 2%
  @media only screen and (max-width: 767px) {
    padding 1% 2.5%
  }
.title_shop
  margin 10px 0 -4px
  color #014998
  font-family: 'Yu Mincho', YuMincho, 'Hiragino Mincho ProN', 'Hiragino Mincho Pro', 'HGP\660E\671D B', serif;
  font-size: 28px;
  line-height: 1.5 !important;
  letter-spacing: .05em;
  @media only screen and (max-width: 767px) {
    font-size: 22px;
  }

.text_shop
  margin-top 0
  //
  font-size 12px
  line-height 1.6
  letter-spacing .05em
  @media only screen and (max-width: 767px) {
    display none
    font-size 11px
  }

.wrap_avatar
  justify-content center
  padding-top 28px
  padding-left 2%
  padding-bottom 18px
  background-color #fff
  @media only screen and (max-width: 767px) {
    flex-direction column
    padding 20px 4% 10px
  }
  .q-item__section--main
    flex inherit
  .q-item__section
    margin-right 8px
  .q-badge
    font-size 11px

.wrap_avatar_img
  background-color #f7f7f7
  border-radius 3px

.wrap_btn_more
  display table !important
  text-align center !important
  margin 12px auto 0

.wrap_shop
  max-width: 1480px;
  margin: 100px auto 0;
  // background-image: url('../assets/images/common/contents_bg0.svg');
  background-color: #fff;
  background-repeat: repeat;
  //
  border-radius 5px

.inner_scroll
  align-content space-between

.search_item
  width calc( (100% / 3) - 0px ) !important
  padding 10px
  @media only screen and (max-width: 1200px) {
    width calc( (100% / 2) - 0px ) !important
  }
  @media only screen and (max-width: 767px) {
    width calc( (100% / 1) - 0px ) !important
  }
  @media only screen and (max-width: 560px) {
    width 100% !important
    padding 10px 0
  }
/*color #fff*/
.btn_cart
  background #004898 !important
  color #fff
.btn_other
  margin-left auto
.text_price
  padding-top 4px
  span
    display inline-block
  .text_tax
    position relative
    top -4px
  .normal
    font-size 17px
    line-height 1.5
  .small
    font-size 10px
  .en
    font-size 12px

.wrap_carousel_serchresult
  padding 0
.q-carousel
  height 260px
.wrap_text_item
  padding-right 10px
.wrap_menu_item
  background-color #f9f9f9

.wrap_table {
  table {
    border-collapse: separate;
    background: #fff;
    @include border-radius(5px);
    margin: 0 auto 80px;
  }

  thead {
    border-radius: 5px;
  }

  thead th {
    font-size: 20px;
    font-weight:400;
    letter-spacing: .05em;
    color: #000;
    text-align:left;
    padding:20px;
    border-top:1px solid #858d99;
  }

  tbody td {
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    color: #5f6062;
    font-size: 17px;
    letter-spacing: .06em;
    padding: 20px 20px 20px 20px;
    border-bottom: 1px solid #e0e0e0;
    
  }

  tbody tr:nth-child(2n) {
    background:#f0f3f5;
  }

  tbody tr:last-child td {
    border-bottom:none;
    &:first-child {
      @include border-bottom-left-radius(5px);
    }
    &:last-child {
      @include border-bottom-right-radius(5px);
    }
  }

  tbody:hover > tr td {
    @include opacity(0.5);
    
    /* uncomment for blur effect */
    /* color:transparent;
    @include text-shadow(0px 0px 2px rgba(0,0,0,0.8));*/
  }

  tbody:hover > tr:hover td {
    @include text-shadow(none);
    color:#2d2d2d;
    @include opacity(1.0);
  }

}

.l-mv {
  position relative
  width: 100%;
  height: 480px;
  margin-bottom: 60px;
  background-color: #eee;
  background-image: url('https://www.j-reve.co.jp/assets/images/top/bg_contents-main04.jpg');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  @media only screen and (max-width: 767px) {
    height: 420px;
  }
  .title_content {
    position: absolute;
    top: 45%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    z-index: 1;
    color: #D2BE50;
    //
    font-size: 56px;
    @media only screen and (max-width: 767px) {
      top: 50%;
      //
    font-size: 46px;
    }
  }
}

</style>